/* eslint-disable @typescript-eslint/naming-convention */
import { CrossSellM2Suggestions, ReviewedCart } from "@cart-client/interfaces/Cart";
import { isEmpty } from "@swiggy-private/js-utils";
import { createCartItemListWithUUID } from "./CartItemRenderer";

export const getCrossSellSuggestions = (cartResponse: ReviewedCart | null): CrossSellM2Suggestions => {
    const crossSellWidgetData = cartResponse?.data?.cross_sell_widget_data || null;
    const tabs = crossSellWidgetData?.cross_sell_tabs || [];

    const crossSellTabs = tabs?.filter((tab) => !isEmpty(tab?.cross_sell_suggestions));

    return {
        suggestions:
            crossSellTabs?.map((tab) => ({
                ...tab,
                cross_sell_suggestions: createCartItemListWithUUID(tab?.cross_sell_suggestions || []),
            })) || [],
        allCrossSellSuggestionsAdded: crossSellWidgetData?.all_cross_sell_suggestions_added || false,
        allCrossSellSuggestionsAddedText: crossSellWidgetData?.all_cross_sell_suggestions_added_text,
        defaultTabSelected: crossSellTabs?.[0]?.type || null,
        crossSellHeader: {
            title: crossSellWidgetData?.title,
            subtitle: crossSellWidgetData?.subtitle,
            presentationInfo: crossSellWidgetData?.presentation_info,
        },
    };
};
